import AccelByteLogoFull from './AccelByteLogoFull';
import AccelByteLogoIcon from './AccelByteLogoIcon';
import BlackBoxLogoFull from './BlackBoxLogoFull';
import AccelByteLogoSquare from './AccelByteLogoSquare';
import BlackboxLogoSquare from './BlackboxLogoSquare';
import FoundationsLogoSquare from './FoundationsLogoSquare';

export const Logos = {
  AccelByteLogoFull,
  AccelByteLogoIcon,
  BlackBoxLogoFull,
  AccelByteLogoSquare,
  BlackboxLogoSquare,
  FoundationsLogoSquare,
};
